import { faker } from '@faker-js/faker';

/**
 * Flat list of faker.js method paths (e.g. `number.int`) for the build-data-model system prompt.
 */
export function buildFakerTypeMethodList(): string[] {
	const types: string[] = [];
	for (const key of Object.keys(faker)) {
		if (key.startsWith('_')) continue;
		if (key.endsWith('efinitions')) continue;

		const namespace = (faker as unknown as Record<string, unknown>)[key];
		if (namespace === null || typeof namespace !== 'object') continue;

		for (const method of Object.keys(namespace as object)) {
			if (method === 'faker') continue;
			types.push(`${key}.${method}`);
		}
	}
	return types;
}
